<template>
  <o-card class="col-lg-8 mx-auto d-block" :title="$t('medtastic.welcome')">
    <div class="mt-3" v-if="user && !user.email_verified_at">
      <b-alert show variant="warning">{{ $t('core.email_not_verified_error') }}</b-alert>
    </div>
    <div class="mb-3 pre-formatted">
      {{ $t('medtastic.welcome_text') }}

      <div class="d-flex">
        <router-link :to="{ name: 'medtastic.events' }" class="btn btn-primary px-4">
          <fa icon="calendar-alt"></fa>
          {{ $t('medtastic.events') }}
        </router-link>

        <router-link :to="{ name: 'medtastic.contact' }" class="ml-auto btn btn-primary px-4">
          <fa icon="envelope"></fa>
          {{ $t('medtastic.contact') }}
        </router-link>
      </div>

    </div>

    <div class="">
      <hr>

      <p>{{$t('medtastic.sponsored_by')}}</p>

      <div class="pb-3">
        <a href="https://www.janssen.com/" target="_blank">
          <img src="/images/janssen.png" alt="Janssen" style="max-width: 210px; height: auto; margin-right: 20px;">
          <img src="/images/Menarini_Pharma.png" alt="Menarini Pharma" style="max-width: 210px; height: auto; margin-right: 20px;">
          <img src="/images/Amgen.png" alt="Janssen" style="max-width: 210px; height: auto; margin-right: 20px;">
        </a>
      </div>
    </div>

  </o-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    layout: 'user',
    computed: {
      ...mapGetters({
        user: 'auth/user'
      })
    }
  }
</script>
